import React, { useState, useCallback } from 'react';

import { goBack } from '../../lib/helpers';
import { settingApi } from '../../lib/api';
import type { Setting } from '../../lib/types';

import CommonCardPage from '../../components/hoc/common/handbook/CardPage';
import { InnerForm } from './components';
import { getBreadCrumbsByUrlForEdit } from '../../lib/autoBreadcrumbs';

type PageProps = {
  id: number,
};

const entryPointPath = '/admin/setting/';

export default (props: PageProps) => {
  const [data, setData] = useState<Partial<Setting>>({
    id: props.id,
  });

  const breadCrumbs = getBreadCrumbsByUrlForEdit(entryPointPath, props.id);

  const onFetch = useCallback(async () => {
    !!props.id && setData(await settingApi.get(props.id, {}));
  }, [props.id]);

  const onSubmit = async (payload: Setting) => {
    let id = payload.id;
    if (id) {
      await settingApi.update(payload);
    } else {
      let data = await settingApi.add(payload);
      id = data.id;
    }
    await goBack(`${entryPointPath}${id}`);
  };

  const onCancel = async () => {
    if (data.id) {
      await goBack(`${entryPointPath}${data.id}`);
    } else await goBack(`${entryPointPath}`);
  };

  return (
    <CommonCardPage
      pageHeaderProps={{
        breadCrumbs,
        mainHeader: 'Настройки',
      }}
      onFetch={onFetch}
      onSubmit={onSubmit}
      onCancel={onCancel}
    >
      <InnerForm data={data} useFooter noWrapMe />
    </CommonCardPage>
  );
};
